const handleNumberOfListItemsPopUp = (editor,setOpenNumberOfListItemsPopUp,setComponentId) => {


    editor.on('component:create', (component) => {

        if(editor.Commands.isActive('enable-navigate-page') === false){

            if(component.attributes.attributes.wabliname === 'list-pagination'){
                setComponentId(component.ccid);
                setOpenNumberOfListItemsPopUp(true);
            }
        }
    })

}

export default handleNumberOfListItemsPopUp;
